import React from 'react';

import { capitalize } from '@shared/utils/capitalize';

import { ClaimStatus } from '@portal/schema';

export const Status: React.FC<{ status: ClaimStatus }> = ({ status }) => (
  <>{status === ClaimStatus.InReview ? 'In Review' : capitalize(status)}</>
);
